module.exports = __webpack_public_path__ + "img/video-call.e9ee49aa.svg";